<template>
  <el-row>
    <el-col :span="24">
      <div class="contacts_box">
        <div class="contacts_left">
          <div class="left_search">
            <Input
              prefix="ios-search"
              placeholder="请输入科室名称"
              v-model="deskName"
              style="width: 180px"
            />
            <Button type="info" style="margin: 0 10px" @click="getBranch()">
              <Icon type="ios-search" />
            </Button>
            <Button type="info" @click="getRefresh()">
              <Icon type="md-refresh" />
            </Button>
          </div>
          <div class="left_actions">
            <Button type="info" class="actions_btn" @click="addBranch()">
              <Icon type="ios-add-circle-outline" size="16" />
              新增科室
            </Button>
            <Button type="info" class="actions_btn" @click="delBranchModal()">
              <Icon type="ios-trash-outline" size="16" />
              删除科室
            </Button>
          </div>
          <div class="left_branch">
            <el-tree
              ref="tree"
              :data="branchList"
              :show-checkbox="true"
              :props="defaultProps"
              node-key="id"
              @node-click="handleNodeClick"
            >
              <div class="custom-tree-node" slot-scope="{ node }">
                <el-tooltip :content="node.label" placement="top">
                  <span>
                    {{ node.label }}
                    <Icon
                      v-show="node.data.isImportant == 1"
                      type="md-star-outline"
                      size="16"
                      color="red"
                    />
                  </span>
                </el-tooltip>
                <div @click.stop>
                  <el-dropdown
                    placement="bottom-start"
                    @command="handleCommand"
                    trigger="click"
                  >
                    <span style="font-weight: 700; font-size: 16px"> ··· </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{ type: 'add', node: node }"
                        >添加</el-dropdown-item
                      >
                      <el-dropdown-item :command="{ type: 'edit', node: node }"
                        >编辑</el-dropdown-item
                      >
                      <el-dropdown-item :command="{ type: 'del', node: node }"
                        >删除</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </el-tree>
          </div>
        </div>
        <div class="contacts_right">
          <div class="right_title">
            <span class="title_text">{{ title }}</span>
          </div>
          <div class="right_action">
            <Select
              class="btn"
              v-model="mainType"
              prefix="md-people"
              style="width: 120px"
              clearable="true"
            >
              <Option
                v-for="item in userList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
            <Input
              class="btn"
              prefix="ios-search"
              placeholder="搜索人员/电话"
              v-model="userName"
              style="width: 180px"
            />
            <Button class="btn" type="info" @click="getuserName(userName)">
              <Icon type="ios-search" />
            </Button>
            <Button class="btn" type="info" @click="getRefresh()">
              <Icon type="md-refresh" />
            </Button>
            <Button class="btn" type="info" @click="addMember()"> 新增 </Button>
            <Button class="btn" type="info" @click="delMembersModal()">
              删除
            </Button>
            <Button class="btn" type="info" @click="dingdingSync()">
              同步钉钉
            </Button>
            <Button class="btn" type="info" @click="downDeskExcel()">
              科室模板
            </Button>
            <Button class="btn" type="info" @click="importDeskInfo()">
              导入科室
            </Button>
            <Button class="btn" type="info" @click="downPhone()">
              电话模板
            </Button>
            <Button class="btn" type="info" @click="importDeskPhoneInfo()">
              更新电话
            </Button>
            <Button class="btn" type="info" @click="downUser()">
              人员模板
            </Button>
            <Button
              class="btn btn1"
              type="info"
              @click="checkUserImportTemplate()"
            >
              导入人员
            </Button>
            <Button class="btn btn1" type="info" @click="onExportUser()">
              导出人员
            </Button>
          </div>
          <div class="right_table">
            <el-table
              :data="memberList"
              class="table_box"
              height="calc(100vh - 300px)"
              @selection-change="handleSelectionChange"
              :header-cell-style="{ background: '#f8f8f9', color: '#515a6e' }"
            >
              <el-table-column type="selection" width="50" align="center">
              </el-table-column>
              <el-table-column min-width="260" align="center">
                <template slot="header">
                  <span>名称</span>
                </template>
                <template slot-scope="scope">
                  <div class="table_user">
                    <div class="user_img">
                      <el-avatar
                        shape="circle"
                        :size="40"
                        :src="
                          scope.row.avatar
                            ? scope.row.avatar.includes('http')
                              ? scope.row.avatar
                              : IMAGE_HOST + scope.row.avatar
                            : scope.row.avatar
                        "
                        @error="errorHandler"
                      >
                        <img
                          :src="
                            scope.row.sex == 1 ? useravatar_1 : useravatar_2
                          "
                        />
                      </el-avatar>
                    </div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.nickName"
                      placement="bottom"
                    >
                      <div class="user_name">
                        {{ scope.row.nickName }}
                      </div>
                    </el-tooltip>
                    <div class="user_type">
                      <template>
                        <div
                          :class="[
                            'user_type_box',
                            'type_box' + scope.row.mainType,
                            // (scope.row.mainType === 1 &&
                            // (!scope.row.type || scope.row.type === null)
                            //   ? 3
                            //   : scope.row.mainType),
                          ]"
                        >
                          <!-- scope.row.mainType == 1 && (!scope.row.type ||
                          scope.row.type === null) ? "用户" : -->

                          {{
                            scope.row.isAdmin == 1
                              ? "管理员"
                              : scope.row.mainType == 1
                              ? "技术人员"
                              : scope.row.mainType == 2
                              ? "主管"
                              : scope.row.mainType == 3
                              ? "用户"
                              : ""
                          }}
                        </div>
                      </template>
                      <!-- <div :class="['user_type_box', 'type_box' + item]"
                        v-for="item in scope.row.userAllType.split(',')" :key="item">
                        {{
                          item == 2
                            ? (scope.row.mainType == 1 ? '技术人员' : scope.row.mainType == 2 ? '主管' : "")
                            : item == 3
                              ? "用户"
                              : ""
                        }}
                      </div> -->
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="phonenumber"
                label="手机号"
                min-width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.phonenumber"
                    placement="bottom"
                  >
                    <div class="ads_wrapper">
                      {{ scope.row.phonenumber }}
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="jobnumber"
                label="工号"
                min-width="80"
                align="left"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.jobnumber"
                    placement="bottom"
                  >
                    <div class="ads_wrapper">
                      {{ scope.row.jobnumber }}
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="moblie"
                label="科室电话"
                min-width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.moblie"
                    placement="moblie"
                  >
                    <div class="ads_wrapper">
                      {{ scope.row.moblie }}
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="moblie"
                label="核算科室"
                min-width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="scope.row.checkDeskName"
                    placement="moblie"
                  >
                    <div class="ads_wrapper">
                      {{ scope.row.checkDeskName }}
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <!-- <el-table-column label="科室地址" min-width="100" align="center">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" :content="scope.row.ads" placement="bottom">
                    <div class="ads_wrapper">
                      {{ scope.row.ads }}
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="address"
                label="状态"
                min-width="50"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="status_type">
                    <span
                      :style="
                        scope.row.status == 0 ? '' : 'background: #F56C6C'
                      "
                      >{{ scope.row.status == 0 ? "正常" : "停用" }}</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" min-width="90">
                <template slot="header">
                  <span>操作</span>
                </template>
                <template slot-scope="scope">
                  <div>
                    <span class="operation_btn" @click="editMember(scope.row)"
                      >编辑</span
                    >
                    <span
                      class="operation_btn"
                      style="margin-right: 0"
                      @click="delMemberModal(scope.row)"
                      >删除</span
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import editVue from "./edit.vue";
import { IMAGE_HOST } from "@/../config";
import editMemberVue from "./editMember.vue";
import config from "../../../config";
import ImportTemplate from "@/views/components/common/form/officesImportTemplate.vue";
import ImportPhoneTemplate from "@/views/components/common/form/phoneImportTemplate.vue";
import CheckUserImportTemplate from "@/views/components/common/form/checkUserImportTemplate.vue";
import useravatar_1 from "./../../assets/img/useravatar_1.png";
import useravatar_2 from "./../../assets/img/useravatar_2.png";
import dayjs from "dayjs";

export default {
  components: {
    editVue,
    editMemberVue,
  },
  data() {
    return {
      mainType: "",
      userList: [
        {
          value: "1",
          label: "技术人员",
        },
        {
          value: "2",
          label: "主管",
        },
        {
          value: "3",
          label: "用户",
        },
      ],
      branchList: [],
      deskName: "",
      defaultProps: {
        children: "children",
        label: "deskName",
      },
      handleMouse: false,
      handleMouseId: "",
      title: "全部",
      deskId: 0,
      pageNum: 1,
      total: "",
      pageSize: 20,
      memberList: [],
      selectMember: [],
      IMAGE_HOST: IMAGE_HOST,
      useravatar_1: useravatar_1,
      useravatar_2: useravatar_2,
      userName: "",
    };
  },
  created() {
    this.getBranch();
    this.getMember();
  },
  methods: {
    async onExportUser() {
      let ids = "";
      if (this.selectMember.length != 0) {
        ids = this.selectMember.map((item) => item.id).join(",");
      }
      let q = {
        begin: dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
        end: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        // ids,
      };
      this.loading = true;
      let res = await $utils.api.load("/admin/system/user/export", q, "get");
      if (res.code == 200) {
        window.location.href =
          config.API_HOST + `/admin/common/download?fileName=${res.msg}`;
        this.loading = false;
      }
    },
    async downDeskExcel() {
      window.location.href =
        config.API_HOST + `/admin/system/desk/template/download`;
    },
    downPhone() {
      window.location.href =
        config.API_HOST + `/admin/system/desk/template/updateThePhone/download`;
    },
    downUser() {
      window.location.href =
        config.API_HOST + `/admin/system/user/template/userTemplate/download`;
    },
    async checkUserImportTemplate() {
      console.log("0000");
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <CheckUserImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.getMember();
              }}
            ></CheckUserImportTemplate>
          );
        },
      });
    },
    async importDeskInfo() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.getBranch();
              }}
            ></ImportTemplate>
          );
        },
      });
    },

    async importDeskPhoneInfo() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportPhoneTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.getBranch();
              }}
            ></ImportPhoneTemplate>
          );
        },
      });
    },
    async getBranch(value) {
      if (value == "refresh") {
        this.deskName = "";
      }
      let d = {
        deskName: this.deskName,
      };
      let res = await $utils.api.load("admin/system/desk/list", d, "get");
      if (res.code == 200) {
        this.branchList = res.rows;
      }
    },
    async getuserName(value) {
      this.pageSize = 20;
      this.pageNum = 1;
      this.userName = value;
      this.getMember();
      // let d = {
      //   userName: value,
      //   mainType: this.mainType,
      // };
      // let res = await $utils.api.load("admin/system/user/listAll", d, "get");
      // if (res.code == 200) {
      //   this.total = res.total;
      //   this.memberList = res.rows;
      // }
    },
    async getMember() {
      let d = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      if (this.deskId != 0) {
        d.deskId = this.deskId;
      }
      if (this.mainType) {
        d.mainType = this.mainType;
      }
      if (this.userName) {
        d.userName = this.userName;
      }
      let res = await $utils.api.load("admin/system/user/listAll", d, "get");
      if (res.code == 200) {
        this.total = res.total;
        this.memberList = res.rows;
      }
    },
    getRefresh() {
      this.title = "全部";
      this.deskId = 0;
      this.pageSize = 20;
      this.pageNum = 1;
      this.userName = "";
      this.mainType = 0;
      this.getBranch("refresh");
      this.getMember();
    },
    handleMouseEnter(node) {
      this.handleMouse = true;
      this.handleMouseId = node.id;
    },
    handleMouseLeave() {
      this.handleMouse = false;
      this.handleMouseId = "";
    },
    async handleNodeClick(e) {
      this.title =
        e.deskName + `（${e.address}）` + (e.phone ? `（${e.phone}）` : "");
      this.deskId = e.id;
      this.getMember();
      // let d = {
      //     deskId: e.id
      // }
      // let res = await $utils.api.load("admin/system/user/listAll", d, "get")
      // if (res.code == 200) {
      //     this.total = res.total
      //     this.memberList = res.rows
      // }
    },
    handleCommand(command) {
      switch (command.type) {
        case "add":
          this.addBranch(command);
          break;
        case "edit":
          this.addBranch(command);
          break;
        case "del":
          this.delBranchModal(command.node);
          break;
        default:
          break;
      }
    },
    addBranch(command) {
      let title = "新增科室";
      if (command) {
        switch (command.type) {
          case "add":
            title = "新增科室";
            break;
          case "edit":
            title = "编辑科室";
            break;
          default:
            break;
        }
      }
      this.$Modal.success({
        closable: true,
        title: title,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <editVue onBranchModal={this.branchModal} command={command} />
            </div>
          );
        },
      });
    },
    branchModal() {
      this.$Modal.remove();
      this.getBranch();
    },

    async delBranchModal(delIds) {
      if (!delIds && this.$refs.tree.getCheckedKeys(true).length == 0) {
        $utils.toast.success("没有选中的科室！");
        return;
      }
      this.$Modal.success({
        closable: true,
        title: `是否删除${delIds ? "当前" : "已选中"}科室！`,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div style="display:flex; justify-content: center; margin:40px 0;">
              <Button
                type="primary"
                style={{ margin: "0 20px 0 0" }}
                onClick={() =>
                  delIds ? this.delBranch(delIds) : this.delBranch()
                }
              >
                确认
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  this.$Modal.remove();
                }}
              >
                取消
              </Button>
            </div>
          );
        },
      });
    },
    async delMember(node) {
      let d = {};
      let res = await $utils.api.load(
        `admin/system/user/${node.id}`,
        d,
        "DELETE"
      );
      console.log(res);
      if (res.code == 200) {
        $utils.toast.success("删除成功！");
        this.getRefresh();
        this.$Modal.remove();
      }
    },
    async delBranch(delIds) {
      let ids = [];
      if (delIds) {
        ids.push(delIds.data.id);
      } else {
        ids = this.$refs.tree.getCheckedKeys(true);
      }
      let res = await $utils.api.load(
        `/admin/system/desk/${ids}`,
        "",
        "DELETE"
      );
      if (res.code == 200) {
        this.$Modal.remove();
        $utils.toast.success("删除成功");
        this.getBranch();
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getMember();
    },
    handleCurrentChange(currentSize) {
      this.pageNum = currentSize;
      this.getMember();
    },
    handleSelectionChange(e) {
      this.selectMember = e;
      console.log(this.selectMember);
    },
    memberModal() {
      this.$Modal.remove();
      this.pageNum = 1;
      this.pageSize = 20;
      this.deskId = 0;
      this.getMember();
      this.title = "全部";
    },
    addMember() {
      this.$Modal.success({
        title: "新增成员",
        closable: true,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: () => {
          return (
            <div>
              <editMemberVue onMemberModal={this.memberModal} />
            </div>
          );
        },
      });
    },
    editMember(node) {
      this.$Modal.success({
        title: "编辑成员",
        closable: true,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: () => {
          return (
            <div>
              <editMemberVue
                onMemberModal={this.memberModal}
                node={node}
                type="edit"
              />
            </div>
          );
        },
      });
    },
    async delMembers() {
      let d = {};
      let ids = [];
      this.selectMember.forEach((item) => {
        ids.push(item.id);
      });
      let res = await $utils.api.load(
        `admin/system/user/removeBatch/${ids}`,
        d,
        "DELETE"
      );
      if (res.code == 200) {
        $utils.toast.success("批量删除成功！");
        this.memberModal();
      }
    },
    delMemberModal(node) {
      console.log(node);
      this.$Modal.success({
        title: "是否删除当前成员！",
        closable: true,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: () => {
          return (
            <div>
              <div style="display:flex; justify-content: center; margin:40px 0;">
                <Button
                  type="primary"
                  style={{ margin: "0 20px 0 0" }}
                  onClick={() => this.delMember(node)}
                >
                  确认
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    this.$Modal.remove();
                  }}
                >
                  取消
                </Button>
              </div>
            </div>
          );
        },
      });
    },
    delMembersModal() {
      if (this.selectMember.length == 0) {
        $utils.toast.success("没有选中的成员！");
        return;
      }
      this.$Modal.success({
        title: "是否删除已选中成员！",
        closable: true,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: () => {
          return (
            <div>
              <div style="display:flex; justify-content: center; margin:40px 0;">
                <Button
                  type="primary"
                  style={{ margin: "0 20px 0 0" }}
                  onClick={() => this.delMembers()}
                >
                  确认
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    this.$Modal.remove();
                  }}
                >
                  取消
                </Button>
              </div>
            </div>
          );
        },
      });
    },
    async dingdingSync() {
      let d = {};
      let res = await $utils.api.load(
        "/admin/system/desk/synchronizationDeskDD",
        d,
        "get"
      );
      console.log(res);
      if (res.code == 200) {
        this.getRefresh();
      }
    },
    errorHandler() {
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.contacts_box {
  height: calc(100vh - 120px);
  display: flex;
  align-items: flex-start;

  .contacts_left {
    border-right: 1px solid #ebebeb;
    padding: 16px;
    padding-left: 0;
    box-sizing: border-box;
    width: 320px;

    .left_search {
      display: flex;
      justify-content: space-between;
    }

    .left_actions {
      margin: 20px 0;
      display: flex;
      justify-content: space-between;

      .actions_btn {
        width: 46%;
      }
    }

    .left_branch {
      width: 100%;
      // padding-right: 20px;
      height: calc(100vh - 250px);
      overflow: auto;

      .custom-tree-node {
        width: 100%;
        display: flex;
        align-items: center;
      }

      .custom-tree-node span {
        flex: 1 1 auto;
        min-width: 0;
        max-width: 200px;
        /* 可根据实际调整 */
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        align-items: center;
      }

      .custom-tree-node > div {
        flex-shrink: 0;
        margin-left: 8px;
      }
    }
  }

  .contacts_right {
    padding: 16px;
    box-sizing: border-box;
    flex: 1;
    min-width: 0;

    .right_title {
      .title_text {
        font-size: 18px;
        font-weight: 600;
      }
    }

    .right_action {
      .btn {
        margin-right: 5px;
      }

      // display: flex;
      margin: 10px 0;
      // justify-content: space-between;
      align-items: center;
    }

    .right_table {
      width: 100%;

      .table_box {
        .table_user {
          display: flex;
          align-items: center;

          .user_img {
            width: 40px;
            height: 40px;
            border-radius: 4px;
            white-space: nowrap;
            position: relative;

            img {
              width: 40px;
              height: 40px;
              border-radius: 4px;
            }
          }

          .user_name {
            margin: 0 6px;
            white-space: nowrap;
            width: 70px;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: none;
          }

          .user_type {
            display: flex;

            .user_type_box {
              border: 1px solid;
              margin: 0 3px;
              font-size: 10px;
              padding: 0 2px;
              border-radius: 4px;
              line-height: 16px;
              white-space: nowrap;
            }

            .type_box2 {
              color: #2d8cf0;
              border-color: #2d8cf0;
            }

            .type_box1 {
              color: #00b042;
              border-color: #00b042;
            }

            .type_box3,
            .type_box0 {
              color: #ff9200;
              border-color: #ff9200;
            }
          }
        }

        .ads_wrapper {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .status_type {
          display: flex;
          justify-content: center;
          width: 100%;

          > span {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            background: #67c23a;
            color: #fff;
            border-radius: 5px;
            font-size: 12px;
          }
        }

        .operation_btn {
          display: inline-block;
          margin-right: 10px;
          color: #2d8cf0;
          cursor: pointer;
        }
      }

      /deep/ .active {
        background-color: transparent !important;
      }
    }
  }
}

/deep/.el-tree-node:focus > .el-tree-node__content {
  background: #f0faff;
  color: #2d8cf0;
  width: 100%;
}

/deep/.el-tree-node__content {
  padding: 7px 0;
  height: auto;
}

/deep/.el-tree-node__content:hover {
  background: #f0faff;
  color: #2d8cf0;
}

::v-deep {
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner {
      display: inline-block;
    }

    .el-checkbox .el-checkbox__inner {
      display: none;
    }
  }
}

/deep/.el-pagination {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-table {
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    /*滚动条宽度*/
    height: 10px;
    /*滚动条高度*/
  }

  /*定义滚动条轨道 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    box-shadow: 0px 1px 3px #f8f8f9 inset;
    /*滚动条的背景区域的内阴影*/
    border-radius: 10px;
    /*滚动条的背景区域的圆角*/
    background-color: #f8f8f9;
    /*滚动条的背景颜色*/
  }

  /*定义滑块 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    box-shadow: 0px 1px 3px #c2c5ca inset;
    /*滚动条的内阴影*/
    border-radius: 10px;
    /*滚动条的圆角*/
    background-color: #c2c5ca;
    /*滚动条的背景颜色*/
  }
}

.handleMouseTrue {
  display: inline-block;
}

.handleMouseFalse {
  display: none;
}

.el-avatar {
  background: transparent;
}

/deep/ .left_branch::-webkit-scrollbar {
  width: 10px;
  /*滚动条宽度*/
  height: 10px;
  /*滚动条高度*/
}

/*定义滚动条轨道 内阴影+圆角*/
/deep/ .left_branch::-webkit-scrollbar-track {
  box-shadow: 0px 1px 3px #f8f8f9 inset;
  /*滚动条的背景区域的内阴影*/
  border-radius: 10px;
  /*滚动条的背景区域的圆角*/
  background-color: #f8f8f9;
  /*滚动条的背景颜色*/
}

/*定义滑块 内阴影+圆角*/
/deep/ .left_branch::-webkit-scrollbar-thumb {
  box-shadow: 0px 1px 3px #c2c5ca inset;
  /*滚动条的内阴影*/
  border-radius: 10px;
  /*滚动条的圆角*/
  background-color: #c2c5ca;
  /*滚动条的背景颜色*/
}
</style>
